export default __webpack_public_path__ + "static/PC_3_3_1-c6250f2839cb34f996066ec5b23a6359.png";